<template>
    <div v-loading="loading">
        <h3 style="text-align:center;">{{ $t('reports.repSalesTitle') }}</h3>
        <div id="chartByRep" style="height:400px;width:400px;margin:auto;">
        </div>
        <el-table v-if="showTable"
            :data="summarizedData"
            stripe
            sum-text="Total"
            class="card-shadow--small"
            v-show="summarizedData &&  summarizedData.length || loading === false"
            :default-sort = "{prop: 'value', order: 'descending'}"
            height="400"
            show-summary
            style="width: 100%">
            <el-table-column
                prop="lastName"
                :label="$t('sales_orders.rep')"
                sortable
                width="180">
                <template slot-scope="scope">
                    <vue-avatar :size="30" v-bind:username="scope.row.firstName + ' ' + scope.row.lastName" :colors="COLORS_HSL"></vue-avatar>
                    <span style="margin-left: 10px">{{ scope.row.lastName }} {{ scope.row.firstName }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="isValueBased === true"
                prop="value"
                sortable
                :label="$t('reports.values')">
                <template slot-scope="scope">
                    <span>{{ formatAmount(scope.row.value) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="isAgencyFeeBased === true"
                prop="value"
                sortable
                :label="$t('products.agencyFees')">
                <template slot-scope="scope">
                    <span>{{ formatAmount(scope.row.value) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="isRebateBased === true"
                prop="value"
                sortable
                :label="$t('sales_orders.rebate')">
                <template slot-scope="scope">
                    <span>{{ formatAmount(scope.row.value) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="isQuantityBased === true"
                prop="value"
                sortable
                :label="$t('common.QtyBt')">
                <template slot-scope="scope">
                    <span>{{ formatNumber(scope.row.value) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="isQuantityBased === true"
                prop="value9L"
                sortable
                :label="$t('common.Qty9L')">
                <template slot-scope="scope">
                    <span>{{ formatNumber(scope.row.value9L) }}</span>
                </template>
            </el-table-column>
        </el-table>
</div>
</template>
<script>

import * as echarts from 'echarts';
import salesAPI from '@/services/API/sales'
import VueAvatar from '@lossendae/vue-avatar'
import portausUtils from '@/utils/portaus-utils';

export default {
    name: 'SalesByRep',
    props: {
        COLORS_HSL : [
				[0, 0, 76],
			],
        showTable: {
        type: Boolean,
        default: false
        },
        filters: Object,
        type: {
            type: String,
            default: 'VALUE'
        },
        max: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
            loading: true,
            dataByRep: [],
        }
    },
    components: {
        VueAvatar
    },
    methods: {
        formatAmount(amount) {
            return portausUtils.formatAmount(amount, this.$i18n.locale);
        },
        formatNumber(amount) {
            return portausUtils.formatNumber(amount, this.$i18n.locale);
        },
        initData() {
            this.loading = true;
            if (this.filters.inventoryId == null) return null;
            this.getSalesByRep()
                .then((dataByRep) => {
                    this.dataByRep = dataByRep;
                    _.forEach(this.dataByRep, dataByRep => {
                        if (_.get(dataByRep, 'repId') == null) {
                            dataByRep.firstName = '--';
                            dataByRep.lastName = '--';
                        }
                    })
                    this.initChart();
                    this.loading = false;
                }).catch((err) => {
                    this.loading = false;
                })
        },
        getSalesByRep () {
            return salesAPI.getSalesByRep(this.filters);
        },
        initChart () {
            this.chartByRep = echarts.init(document.getElementById('chartByRep'));
            this.chartByRep.setOption({
                title: {
                    show:false,
                    text: "Ventes par représentant",
                    padding:0,
                    left:'center',
                    textAlign:'center'
                },
                tooltip: {
                    show:true,
                    trigger: 'item',
                    appendToBody: true,
                },
                legend: {
                    show:false,
                    orient: 'vertical',
                    left: 'left',
                    selectedMode: false,
                },
                series: [
                    {
                        // name: 'Ventes / Rep.',
                        type: 'pie',
                        radius: ['40%', '60%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                        borderRadius: 10,
                        borderColor: '#fff',
                        borderWidth: 2
                        },
                        label: {
                            show: true,
                            overflow: 'break',
                            width: 75,
                        },
                        // emphasis: {
                        //     label: {
                        //         show: false,
                        //         fontSize: 40,
                        //         fontWeight: 'bold'
                        //     }
                        // },
                        labelLine: {
                            show: true
                        },
                        data: this.chartData,
                    }
                ]
            }, true);
            this.chartByRep.on('click', (params) => this.$emit('change', params.data));
        }
    },
    watch: {
        type: function (val) {
            this.initChart();
        },
        filters: function (val) {
           this.initData();
        }
    },
    computed : {
        isQuantityBased () { 
            return _.upperCase(this.type) === 'QUANTITY';
        },
        isValueBased () { 
            return _.upperCase(this.type) === 'VALUE';
        },
        isAgencyFeeBased () { 
            return _.upperCase(this.type) === 'AGENCYFEES';
        },
        isRebateBased () { 
            return _.upperCase(this.type) === 'REBATE';
        },
        chartData () {
            return _.map(this.dataByType, data => ({ id: data.repId, value: data.value, name: `${data.firstName} ${data.lastName}`, tooltip: { valueFormatter: (value) => !this.isQuantityBased ?  '$' + value : value }}))
        },
        dataByType() {
            if (this.isQuantityBased === true) {
                return this.dataByQty;
            } else if (this.isAgencyFeeBased === true) {
                return this.dataByAgencyFees;
            } else if (this.isRebateBased === true) {
                return this.dataByRebate;
            }           
            return this.dataByValue;

        },
        summarizedData () {
            if (this.max >= 0) {
                return _.slice(this.dataByType, 0, this.max);
            } else {
                return this.dataByType;
            }
        },
        dataByValue () {
            return _.orderBy(_.map(this.dataByRep, data => ({firstName: data.firstName, lastName: data.lastName, repId: data.repId, value: Number(data.value), valueOrder:Number(data.value) })), ['valueOrder'], ['desc']);
        },
        dataByQty () {
            return _.orderBy(_.map(this.dataByRep, data => ({firstName: data.firstName, lastName: data.lastName, repId: data.repId, value: Number(data.qty), value9L: Number(data.qty9l) })), ['value'], ['desc']);
        },
        dataByAgencyFees () {
            return _.orderBy(_.map(this.dataByRep, data => ({firstName: data.firstName, lastName: data.lastName, repId: data.repId, value: Number(data.agencyfees),valueOrder:Number(data.agencyfees)  })), ['valueOrder'], ['desc']);
        },
        dataByRebate () {
            return _.orderBy(_.map(this.dataByRep, data => ({firstName: data.firstName, lastName: data.lastName, repId: data.repId, value: Number(data.discount), valueOrder:Number(data.discount) })), ['valueOrder'], ['desc']);
        }
    },
    mounted() {
        this.initData();
    }
   
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


</style>
  